import AjaxClass from '../modules/Forms/Validation/ajaxClass';

const swiperHero = new Swiper(".swiper-hero", {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: true,
    speed: 1000,

    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-hero .swiper-pagination',
        clickable: true,
    },
});

document.addEventListener("DOMContentLoaded", () => {
    setSwiperDirection();
    slideExpandEffect();
    handleGalleryLoadMoreClick();

    window.addEventListener('resize', setSwiperDirection);

    let ctaHero = document.querySelector('.hero .btn');
    ctaHero.addEventListener('click', (e) => {
        e.preventDefault();
        scrollTo('#portfolio');
    })

    function scrollTo(section) {
        let sectionEl = document.querySelector(section);

        if (sectionEl) {
            if ( window.innerWidth > 992 ) {
                // lenis scroll
                window.lenis.scrollTo(sectionEl, {
                    duration: 1.2,
                    easing: (t) => t * (2 - t),
                });
            } else {
                // scroll nativo
                sectionEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    }

    function setSwiperDirection() {
        let swiper = document.querySelector('.swiper-gallery');
        let isMobile = window.innerWidth < 992 ? true : false;

        if ( !isMobile ) {
            swiper.setAttribute("dir", "rtl");
        } else {
            swiper.removeAttribute("dir");
        }
    }

    function slideExpandEffect() {
        let swiperSlides = document.querySelectorAll('.swiper-gallery .swiper-slide');

        swiperSlides.forEach(slide => {
            slide.addEventListener('click', function() {
                swiperSlides.forEach(sl => sl.classList.remove('clicked'))
                this.classList.add('clicked');
            })
        })
    }

    function handleGalleryLoadMoreClick() {
        let swiperGallery = document.querySelector('.swiper.swiper-gallery');
        let btnLoadMore = document.getElementById('load-more-home');

        btnLoadMore.addEventListener('click', function() {
            swiperGallery.classList.add('expand')
        })
    }

    // swipers
    const swiperHighlights = new Swiper(".swiper-highlights", {
        slidesPerView: 1,
        spaceBetween: 253,
        centeredSlides: true,
        loop: true,
        speed: 1000,

        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: "auto",
            },
        }
    });

    const swiperGallery = new Swiper(".swiper-gallery", {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        speed: 900,

        breakpoints: {
            992: {
                slidesPerView: "auto",
                centeredSlides: false,

                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                }
            },
        }
    });

    //galeria carregar mais
    document.addEventListener('click', function(e) {
        const loadMoreBtn = e.target.closest("#load-more-home");
        if (loadMoreBtn) {
            e.preventDefault();
            class LoadCards extends AjaxClass {
                successFunction(html) {
                    const btn = document.getElementById("load-more-home");
                    let nextPage = parseInt(btn.getAttribute('nextPage'));
                    let lastPage = parseInt(btn.getAttribute('lastPage'));
                    if (nextPage >= lastPage) {
                        btn.remove();
                    }
                    loadMoreBtn.setAttribute('nextPage', nextPage++);
                    if (html) {
                        const cardsDiv = document.getElementById("cardsDiv");
                        if (cardsDiv) cardsDiv.insertAdjacentHTML('beforeend', html);
                    }
                    swiperGallery.update();
                    slideExpandEffect();
                }
    
                errorFunction() {
                }
            }
            let url = '';
            let nextPage = parseInt(loadMoreBtn.getAttribute('nextPage'));
            
            let loadPosts = new LoadCards(null, 'get', url, 'html', 'page=' + nextPage);
            loadPosts.sendNoRecaptcha();
        }
    });
})
